import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Collapse as AntCollapse } from 'antd';
import styled from 'styled-components';
import { setLightness } from 'polished';
var Collapse = styled(AntCollapse)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-collapse {\n    border-radius: 0;\n  }\n\n  .ant-collapse-item.ant-collapse-item-active > .ant-collapse-header {\n    background-color: ", ";\n  }\n\n  .ant-collapse-header {\n    background-color: ", ";\n\n    ", "\n  }\n\n  .ant-collapse-content > .ant-collapse-content-box {\n    padding: ", ";\n  }\n\n  &.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.darkenHeaderOnExpanded || props.darkenHeader ? setLightness(0.875, props.theme.colors.grey) : props.theme.colors.light;
}, function (props) {
  return props.darkenHeader ? setLightness(0.875, props.theme.colors.grey) : props.theme.colors.light;
}, function (props) {
  return props.contentOnly && "\n      display: none;\n    ";
}, function (props) {
  return props.compactBody && '0';
}, function (props) {
  return props.theme.colors.light;
});
Collapse.defaultProps = {
  compactBody: false,
  contentOnly: false,
  darkenHeaderOnExpanded: false,
  darkenHeader: false,
  bordered: true
};
export default Collapse;